import { WorkspaceLayout } from '@components-system/layouts';

export const layoutCourse = {
  id: "layout.course",
  cat: "layout",
  type: "course",
  Component: WorkspaceLayout,
  props: {
    sidebarItems: [
      {
        id: "menu.course.dashboard",
        to: "/courses/:courseId/dashboard",
        label: "Dashboard",
        icon: "dashboard",
      },
      {
        id: "menu.course.students",
        to: "/courses/:courseId/students",
        label: "Students",
        icon: "student",
      },
      {
        id: "menu.course.lecturers",
        to: "/courses/:courseId/lecturers",
        label: "Lecturers",
        icon: "lecturer",
      },
      {
        id: "menu.course.resources",
        to: "/courses/:courseId/resources",
        label: "Resources",
        icon: "resources",
      },
      {
        id: "menu.course.assignments",
        to: "/courses/:courseId/assignments",
        label: "Assignments",
        icon: "assignments",
      },
      // {
      //   to: "/courses/:id/groups",
      //   label: "Groups",
      //   icon: "Groups",
      // }
    ],
    menuProfile: {
      children: [
        {
          id: "admin_11",
          children: "Profile332",
          to: "/users/profile",
        },
        {
          id: "admin_13",
          children: "Settings",
          to: "/users/settings",
        },
        {
          id: "admin_12",
          children: "Management",
          to: "/management",
        },
        {
          id: "admin_12",
          children: "Lecturers",
          to: "/lecturers",
        },
        {
          id: "admin_14",
          children: "Students",
          to: "/students",
        },
      ],
    } as any,
  },
};
